import { apiRequest } from '@/utils/request'

export function getAtbdcqzs(queryParams) {
  return apiRequest({
    url: '/Atbdcqzs',
    method: 'get',
    params: queryParams
  })
}

export function getAtbdcqzsList(queryParams) {
  return apiRequest({
    url: '/Atbdcqzs/GetList',
    method: 'get',
    params: queryParams
  })
}